import { traveler as travelerUtils } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import { TravelerDescription as TravelerDescriptionComponent } from '@eti/components';
import { jsx as _jsx } from "react/jsx-runtime";
const TravelerDescription = ({
  className,
  name,
  shouldShowIcon,
  type
}) => {
  const {
    t
  } = useTranslation();
  const ageType = type !== null && type !== void 0 ? type : '';
  const description = travelerUtils.resolveLabelFromType(ageType, t('Adult'), t('Child'), t('Infant'));
  return /*#__PURE__*/_jsx(TravelerDescriptionComponent, {
    className: className,
    description: description,
    name: name,
    shouldShowIcon: shouldShowIcon,
    type: type
  });
};
export default TravelerDescription;
//# sourceMappingURL=TravelerDescription.js.map